import { DeviceUUID } from "device-uuid";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import authService from "../../Services/authService";
import utils from "../../Utils";
import strings from "../../Utils/strings";
import ActiveOTP from "../otpActiveFunction/activeOTP";
import "./verifyMobileOTP.css";
import { useTranslation } from "react-i18next";
import clinicService from "../../Services/clinicService";

function MobileOtpVerify(props) {
  const { receivedOTP, code, mobile } = props;
  const { t } = useTranslation();
  const nav = useNavigate();
  const [error, setError] = useState("");
  const [otpValue, setOtpValue] = useState("");
  const [enableResendOTP, setEnableResendOtp] = useState(false);
  const [timeLeft, setTimeLeft] = useState(utils.constants.resendCodeTime);
  const [deviceId, setDeviceId] = useState("");
  const timeInterval = 1000;

  useEffect(() => {
    setEnableResendOtp(false);
    const timer = setTimeout(() => {
      if (timeLeft > 0) {
        setTimeLeft(timeLeft - timeInterval);
      } else {
        setTimeout(0);
        setEnableResendOtp(true);
        clearTimeout(timer);
      }
    }, timeInterval);
    return () => clearTimeout(timer);
  }, [timeLeft]);

  const validateSession = () => {
    if (authService.getToken()) {
      nav(strings.navigation.approvedAppointment);
      // window.location.reload();
    }
  };

  useEffect(() => {
    validateSession();
    const deviceUUID = new DeviceUUID().get();
    setDeviceId(deviceUUID);
    // authService.setCountryCode(state.state.countryCode)
  }, []);

  const handleResendOTP = () => {
    // resendOTP()
    setTimeLeft(utils.constants.resendCodeTime);
  };

  const pull_data = (data) => {
    setOtpValue(data);
  };

  const HospitalLogin = async () => {
    let body = {
      countryCode: code,
      phoneNumber: mobile,
    };
    try {
      let response = await clinicService.hospitalLogin(body);
      if ((response.data.success = "success")) {
        authService.setToken(response.data.token);
        authService.setClinicId(response.data.hospital._id);
        authService.setPhoneNumber(response.data.hospital.phoneNumber);
        authService.setCountryCode(response.data.hospital.countryCode);
        authService.setHospitalAddress(response.data.hospital.address);
        authService.setClinicName(response.data.hospital.name);
        authService.setIsDoctorLogin(false);
        nav(strings.navigation.dashboard);
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const validateOtp = async (e) => {
    e.preventDefault();
    try {
      // const isOTPVerified = (otp === '770000');
      const isOTPVerified = true;
      // const isOTPVerified = await receivedOTP.confirm(otpValue);
      console.log("isOTPVerified:", isOTPVerified);
      if (isOTPVerified) {
        toast.success("Otp verified");
        HospitalLogin();
        return true;
      } else {
        toast.error("Incorrect OTP");
        return false;
      }
    } catch (error) {
      toast.error("Incorrect OTP");
      console.error("Error", error);
      return false;
    }
  };

  return (
    <>
      <div className="detail-container p-3" style={{ alignItems: "center" }}>
        <h5 className="login-title">{t("mobileVerify")}</h5>
        <h6 className="sub-title ml-3 mt-2">{t("mobileVerifySubTitle")}</h6>
        <ActiveOTP func={pull_data} error={""} />
        <div className="mt-3">
          {error != "" ? (
            <span className="d-flex error-container">
              <i className="ri-information-line me-1" />
              {error}
            </span>
          ) : null}
        </div>
        <button
          type="submit"
          className="buttonStyle mt-4 w-full text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center"
          disabled={otpValue.length !== 6}
          onClick={(e) => {
            validateOtp(e);
          }}
        >
          {t("labelVerify")}
        </button>
        <div className="countdown-text register-footer ">
          {enableResendOTP ? (
            <h6 onClick={() => handleResendOTP()} className=" col-md-12 resend text-nowrap mt-2">
              {t("labelResend")}
            </h6>
          ) : (
            <div className=" d-flex justify-content-center ">
              <span className="already-register me-2">{t("signUp")}</span>
              <span className="timer">{`00 : ${timeLeft / 1000} secs`}</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MobileOtpVerify;
